export const yesNoOption = [
    {value: "Yes", display_value: "Yes"},
    {value: "No", display_value: "No"}
];
// The involvement options depend on the deal, so the same list has to drive the
// radio group and the validator. Keeping them apart let a stored value that is not
// on screen (e.g. "Landlord" on a Sale) render as nothing selected while still
// passing the "not empty" check.
export const getClientTypeOptions = (transactionType, transactionId) => {
    const hasTransaction = transactionId && transactionId !== "None" && transactionId !== "" && transactionId !== 0;
    const base = transactionType === "Sale" || transactionType === "Purchase"
        ? ["Vendor", "Purchaser"]
        : ["Landlord", "Tenant"];
    const values = hasTransaction ? base : [...base, "No Transaction"];
    return values.map((value) => ({ value, display_value: value }));
};
